document.addEventListener("DOMContentLoaded", function() {
    const counters = document.querySelectorAll('.count');
    function startCounter(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const targetValue = entry.target.getAttribute('data-target');
          const target = parseFloat(targetValue.replace(/[^\d.-]/g, '')); // Remove non-numeric characters
          if (!isNaN(target)) {
            const increment = target / 200; // Adjust the increment value as needed
            let count = 0;
            // Function to update the counter value
            function updateCount() {
              count += increment;
              // Format the count as desired
              let formattedCount = count.toLocaleString('en-IN'); // Use Indian Numbering System for formatting (10,00,000)
              if (count >= target) {
                formattedCount += '+'; // Add plus sign if the count exceeds or equals the target
              }
              entry.target.innerText = formattedCount;

              // Stop when reaching the target value
              if (count < target) {
                requestAnimationFrame(updateCount);
              }
            }
            // Call the updateCount function
            updateCount();
            // Unobserve the target once counting is done
            observer.unobserve(entry.target);
          }
        }
      });
    }
    // Create a new Intersection Observer
    const observer = new IntersectionObserver(startCounter, { threshold: 0.5 });
    // Observe each counter element
    counters.forEach(counter => {
      observer.observe(counter);
    });
  });